import {
  ANGEL_GUILD_PREMIUM_YEARLY_OFFER_ID,
  ANGEL_GUILD_PREMIUM_MONTHLY_OFFER_ID,
  ANGEL_GUILD_BASIC_MONTHLY_OFFER_ID,
  ANGEL_GUILD_BASIC_YEARLY_OFFER_ID,
  ANGEL_GUILD_BASIC_NO_ADS_MONTHLY_OFFER_ID,
  ANGEL_GUILD_BASIC_NO_ADS_YEARLY_OFFER_ID,
} from '@/constants/offer-ids'

export const RECURLY_PREMIUM_YEARLY_PLAN_ID = 'premium-yearly'
export const RECURLY_PREMIUM_MONTHLY_PLAN_ID = 'premium-monthly'
export const RECURLY_BASIC_MONTHLY_PLAN_ID = 'basic-monthly'
export const RECURLY_BASIC_YEARLY_PLAN_ID = 'basic-yearly'
export const RECURLY_BASIC_NO_ADS_MONTHLY_PLAN_ID = 'basic-no-ads-monthly'
export const RECURLY_BASIC_NO_ADS_YEARLY_PLAN_ID = 'basic-no-ads-yearly'

export const GUILD_OFFER_RECURLY_PLAN_MAP = {
  [ANGEL_GUILD_PREMIUM_MONTHLY_OFFER_ID]: RECURLY_PREMIUM_MONTHLY_PLAN_ID,
  [ANGEL_GUILD_PREMIUM_YEARLY_OFFER_ID]: RECURLY_PREMIUM_YEARLY_PLAN_ID,
  [ANGEL_GUILD_BASIC_MONTHLY_OFFER_ID]: RECURLY_BASIC_MONTHLY_PLAN_ID,
  [ANGEL_GUILD_BASIC_YEARLY_OFFER_ID]: RECURLY_BASIC_YEARLY_PLAN_ID,
  [ANGEL_GUILD_BASIC_NO_ADS_MONTHLY_OFFER_ID]: RECURLY_BASIC_NO_ADS_MONTHLY_PLAN_ID,
  [ANGEL_GUILD_BASIC_NO_ADS_YEARLY_OFFER_ID]: RECURLY_BASIC_NO_ADS_YEARLY_PLAN_ID,
}
